/*
  InStyle — product cards settle into place the first time they scroll into view.
  ------------------------------------------------------------------
  Accents@Home's cards carry `data-motion="zoom-out-sm"`: the photo starts a
  touch large and eases back to rest as the card arrives. This is that, for
  `.instyle-card[data-isc-reveal]` (snippets/instyle-card.liquid): the photo
  box goes from scale 1.04 to 1 over 600ms (assets/instyle-collection.css,
  `.is-armed`), ONCE per card.

  Arm only what is still below the fold. A card already on screen at load is
  left exactly as it is, as assets/instyle-reveal.js does for sections:
  animating something the visitor is already looking at reads as a glitch.

  No IntersectionObserver, or prefers-reduced-motion: nothing is armed, so the
  photo simply sits at rest. Nothing here ever hides a card; the worst a
  failure can do is leave a photo 4% larger inside its own box.

  Hardening (context/scroll-animation-rules.md, ungated on every device):
    R5  never one event as the only escape: an armed card is released by the
        observer, or by the sweep below, whichever comes first
    R6  a backgrounded tab can drop observer callbacks, and a bfcache restore
        fires no load event: `visibilitychange` and `pageshow` release every
        armed card that is on screen

  Filters and sort re-render the grid without a reload (Dawn's facets.js), and
  the theme editor swaps sections in place, so new cards are picked up by a
  MutationObserver. Several sections may include this file; a second run only
  re-scans.
*/
(function () {
  'use strict';

  if (window.InStyleCardMotion) {
    window.InStyleCardMotion.scan(document);
    return;
  }

  var SELECTOR = '.instyle-card[data-isc-reveal]';
  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  var armed = [];

  function reveal(card) {
    card.classList.remove('is-armed');
    var i = armed.indexOf(card);
    if (i !== -1) armed.splice(i, 1);
    if (io) io.unobserve(card);
  }

  if (!REDUCED && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) reveal(entries[i].target);
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
    );
  }

  function wire(card) {
    // An expando, not an attribute: a cloned card must be wired again.
    if (card._iscWired) return;
    card._iscWired = true;
    if (!io) return;
    var box = card.getBoundingClientRect();
    if (box.top < window.innerHeight * 0.9 && box.bottom > 0) return;
    card.classList.add('is-armed');
    armed.push(card);
    io.observe(card);
  }

  function scan(root) {
    var cards = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < cards.length; i++) wire(cards[i]);
  }

  function sweep() {
    var h = window.innerHeight;
    armed.slice().forEach(function (card) {
      var box = card.getBoundingClientRect();
      if (box.top < h && box.bottom > 0) reveal(card);
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sweep();
  });
  window.addEventListener('pageshow', sweep);
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });

  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function (records) {
      if (queued) return;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            scan(document);
          });
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.InStyleCardMotion = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
